// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MS_button_ace {
    color: black;
    border-color: black;
}

.MS_button_ace:focus {
    background-color: white !important;
    color: #358696;

}

.MS_button_ace:hover {
    background-color: #358696 !important;
}

.ms_btn_ace.btn:focus,
.ms_btn_ace.btn:focus-visible,
.ms_btn_ace.btn:focus-within,
.ms_btn_ace.btn:hover,
.ms_btn_ace.btn:visited,
.ms_btn_ace.btn:active,
.ms_btn_ace.btn:target {
    color: #fff !important;
    background-color: #358696 !important;
    border-color: #358696 !important;
}

.ms_btn_ace.btn {
    color: #358696 !important;
    border: 2px solid #2a6b74;
    /* 👈 visible border, slightly darker teal */
    border-radius: 6px;
    border-width: 1px;
}

.ms_btn_ace.btn.active {
    color: #ffffff !important;
    border-color: black !important;
    background-color: #358696 !important;
}

.ms_btn_ace_2 {
    color: black;
    background-color: white;
}

.cursor_pointer_ace {
    cursor: pointer;
}


.custom-tooltip .tooltip-inner {
    background-color: white !important;
    color: rgb(34, 32, 32) !important;
    border: 1px solid #ccc;
    font-size: 0.8rem;
    padding: 4px
        /* optional */
}

.custom-tooltip.bs-tooltip-top .tooltip-arrow::before,
.custom-tooltip.bs-tooltip-bottom .tooltip-arrow::before,
.custom-tooltip.bs-tooltip-left .tooltip-arrow::before,
.custom-tooltip.bs-tooltip-right .tooltip-arrow::before {
    border-top-color: white !important;
    border-bottom-color: white !important;
    border-left-color: white !important;
    border-right-color: white !important;
}


.ms_btn_close.btn:focus,
.ms_btn_close.btn:focus-visible,
.ms_btn_close.btn:focus-within,
.ms_btn_close.btn:hover,
.ms_btn_close.btn:visited,
.ms_btn_close.btn:active,
.ms_btn_close.btn:target {
    color: #fff !important;
    background-color: #358696 !important;
    border-color: #358696 !important;
}

.ms_btn_close.btn {
    color: #358696 !important;
    border-color: #358696 !important;
}

.ms_btn_close.btn.active_ace {
    color: #ffffff !important;
    border-color: #358696 !important;
    background-color: #358696 !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,cAAc;;AAElB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;;IAOI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,4CAA4C;IAC5C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;QACP,aAAa;AACrB;;AAEA;;;;IAII,kCAAkC;IAClC,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;AACxC;;;AAGA;;;;;;;IAOI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;AACxC","sourcesContent":[".MS_button_ace {\n    color: black;\n    border-color: black;\n}\n\n.MS_button_ace:focus {\n    background-color: white !important;\n    color: #358696;\n\n}\n\n.MS_button_ace:hover {\n    background-color: #358696 !important;\n}\n\n.ms_btn_ace.btn:focus,\n.ms_btn_ace.btn:focus-visible,\n.ms_btn_ace.btn:focus-within,\n.ms_btn_ace.btn:hover,\n.ms_btn_ace.btn:visited,\n.ms_btn_ace.btn:active,\n.ms_btn_ace.btn:target {\n    color: #fff !important;\n    background-color: #358696 !important;\n    border-color: #358696 !important;\n}\n\n.ms_btn_ace.btn {\n    color: #358696 !important;\n    border: 2px solid #2a6b74;\n    /* 👈 visible border, slightly darker teal */\n    border-radius: 6px;\n    border-width: 1px;\n}\n\n.ms_btn_ace.btn.active {\n    color: #ffffff !important;\n    border-color: black !important;\n    background-color: #358696 !important;\n}\n\n.ms_btn_ace_2 {\n    color: black;\n    background-color: white;\n}\n\n.cursor_pointer_ace {\n    cursor: pointer;\n}\n\n\n.custom-tooltip .tooltip-inner {\n    background-color: white !important;\n    color: rgb(34, 32, 32) !important;\n    border: 1px solid #ccc;\n    font-size: 0.8rem;\n    padding: 4px\n        /* optional */\n}\n\n.custom-tooltip.bs-tooltip-top .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-bottom .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-left .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-right .tooltip-arrow::before {\n    border-top-color: white !important;\n    border-bottom-color: white !important;\n    border-left-color: white !important;\n    border-right-color: white !important;\n}\n\n\n.ms_btn_close.btn:focus,\n.ms_btn_close.btn:focus-visible,\n.ms_btn_close.btn:focus-within,\n.ms_btn_close.btn:hover,\n.ms_btn_close.btn:visited,\n.ms_btn_close.btn:active,\n.ms_btn_close.btn:target {\n    color: #fff !important;\n    background-color: #358696 !important;\n    border-color: #358696 !important;\n}\n\n.ms_btn_close.btn {\n    color: #358696 !important;\n    border-color: #358696 !important;\n}\n\n.ms_btn_close.btn.active_ace {\n    color: #ffffff !important;\n    border-color: #358696 !important;\n    background-color: #358696 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
